export default defineNuxtPlugin((nuxtApp) => {
  const { appDebug } = useRuntimeConfig()

  if (!appDebug) {
    // Suppress specific Vue router warnings
    nuxtApp.vueApp.config.warnHandler = (msg) => {
      if (msg.includes('[Vue Router warn]:')) return
    }

    const originalWarn = console.warn
    console.warn = (...args) => {
      // Filter out specific warning messages
      if (
        typeof args[0] === 'string' &&
        args[0].includes('[Vue Router warn]:')
      ) {
        return
      }

      originalWarn(...args)
    }
  }
})
